import 'bootstrap';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ?? `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });



// pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';


/************************************************************** ondemand **************************************************************/

let modalElement, modal = null;

window.addEventListener("DOMContentLoaded", () => {
    var modalElement = document.getElementById('previewModal');
    if(modalElement){
        modal = new window.bootstrap.Modal(modalElement);
    }

    const page = window.location.pathname;

    if(page === '/program'){

    }
})

if(modal){
    modalElement.addEventListener('hidden.bs.modal', function (event) {
        var canvas = document.getElementById('preview');
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    });
}


function renderPreview(pdfDoc) {
    pdfDoc.getPage(1).then(function(page) {
        const canvas = document.getElementById('preview');
        const context = canvas.getContext('2d');
        const viewport = page.getViewport({ scale: 1.5 });
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        page.render({
            canvasContext: context,
            viewport: viewport
        });

        modal.show();
    });
}


window.loadPreview = function(url){
    pdfjsLib.getDocument(url).promise.then(function(pdf) {
        renderPreview(pdf);
    });
}




/************************************************************** program **************************************************************/


function loadAgendaPDF(pdfDoc) {
    pdfDoc.getPage(1).then(function(page) {
        const canvas = document.getElementById('current_agenda');
        const context = canvas.getContext('2d');
        const viewport = page.getViewport({ scale: 1.5 });
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        page.render({
            canvasContext: context,
            viewport: viewport
        });
    });
}


window.setAgenda = function(agenda, url){
    const element = document.getElementById(agenda);
    const buttons = document.getElementsByClassName('agenda-button');

    for (const btn of buttons) {
        if(btn.id !== agenda){
            btn.classList.remove('selected');
        }
    }
    
    element.classList.add('selected');

    pdfjsLib.getDocument(url).promise.then(function(pdf) {
        loadAgendaPDF(pdf);
    });
}